module.exports = __webpack_public_path__ + "static/4-3b0041d750619d3e0cad5244479a02e1.jpg";